import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProfileResidenceResponse, ProfileResidenceModalData } from '../../models/profile-residence.model';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmResidenceChangeModalComponent } from '../../components/confirm-residence-change-modal/confirm-residence-change-modal.component';
import { take } from 'rxjs/operators';
import { FormTracking } from '../../../../config/eev-form-tracking.config';
import { AuthFormFieldName, AuthFormName, AuthLinkType } from '../../../../enums/event/event-data.enum';

@Component({
    selector: 'app-profile-residence-edit',
    templateUrl: './profile-residence-edit.component.html',
    styleUrls: ['./profile-residence-edit.component.scss'],
    standalone: false
})
export class ProfileResidenceEditComponent implements OnInit {
  residenceFormTrackingConfig = FormTracking[AuthFormName.PROFILE_RESIDENCE_EDIT];
  @Input() residenceForm: FormGroup;
  @Input() residenceData: ProfileResidenceResponse;
  @Input() ownershipStatuses;
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  cid = this.cookieService.get('cid');
  AuthFormFieldName = AuthFormFieldName;
  AuthLinkType = AuthLinkType;

  constructor(private readonly cookieService: CookieService, private readonly dialog: MatDialog) {}

  ngOnInit(): void {}

  updateResidence() {
    if (
      !this.residenceForm.controls['ownershipStatusId'].value &&
      !this.residenceForm.controls['ownershipStatusId'].value
    ) {
      return;
    }
    const modalData: ProfileResidenceModalData = {
      profileType: 'residence',
      cid: this.cid,
      ownershipStatusId: this.residenceForm.controls['ownershipStatusId'].value?.value,
      monthlyPayment: this.residenceForm.controls['monthlyPayment'].value,
    };

    if (this.residenceData) {
      modalData.id = this.residenceData.id;
      modalData.residenceId = this.residenceData.residenceId;
    }

    this.dialog
      .open(ConfirmResidenceChangeModalComponent, {
        data: modalData,
        maxWidth: '529px',
        panelClass: 'be-dialog',
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((data) => {
        if (!data) {
        } else {
          this.onCancel.emit();
        }
      });
  }
}
